<script setup>
import { ref } from 'vue'
import { firstFieldError } from './catalogErrors.mjs'

const props = defineProps({
  modelValue: { type: Object, required: true },
  fieldErrors: { type: Object, default: () => ({}) },
  disabled: Boolean,
})
const emit = defineEmits(['update:modelValue'])
const activeLocale = ref('uk')

function update(field, value) {
  emit('update:modelValue', {
    ...props.modelValue,
    [activeLocale.value]: { ...(props.modelValue[activeLocale.value] || {}), [field]: value },
  })
}

function error(field) {
  return firstFieldError(props.fieldErrors, `translations.${activeLocale.value}.${field}`)
}
</script>

<template>
  <div>
    <div class="nav nav-tabs mb-3" role="tablist" aria-label="Мови перекладу">
      <button v-for="locale in [{ id: 'uk', label: 'Українська' }, { id: 'en', label: 'English' }]" :key="locale.id"
        class="nav-link" :class="{ active: activeLocale === locale.id }" type="button" role="tab"
        :aria-selected="activeLocale === locale.id" @click="activeLocale = locale.id">
        {{ locale.label }}<span v-if="locale.id === 'uk'" class="text-danger ms-1" aria-label="обов'язково">*</span>
      </button>
    </div>
    <div role="tabpanel">
      <label class="form-label" :for="`translation-${activeLocale}-name`">Назва</label>
      <input :id="`translation-${activeLocale}-name`" class="form-control" :class="{ 'is-invalid': error('name') }"
        :value="modelValue[activeLocale]?.name || ''" :disabled="disabled" :required="activeLocale === 'uk'"
        @input="update('name', $event.target.value)">
      <div v-if="error('name')" class="invalid-feedback">{{ error('name') }}</div>

      <label class="form-label mt-3" :for="`translation-${activeLocale}-description`">Опис</label>
      <textarea :id="`translation-${activeLocale}-description`" class="form-control" rows="5"
        :class="{ 'is-invalid': error('description') }" :value="modelValue[activeLocale]?.description || ''"
        :disabled="disabled" @input="update('description', $event.target.value)"></textarea>
      <div v-if="error('description')" class="invalid-feedback">{{ error('description') }}</div>
    </div>
  </div>
</template>
